import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import * as orgActions from '../../../../redux/organisations';
import useDebouncedState from '../../../../hooks/useDebouncedState';
import { Organisation } from '../../../../types/organisation';

interface OrganisationSearchReturn {
  search: (text: string) => void;
  organisations: Organisation[];
}

const useOrganisationSearch = (): OrganisationSearchReturn => {
  const dispatch = useDispatch();
  const searchResults = useSelector((state: RootStateOrAny) => state.organisations.searchResults);

  const search = useCallback(
    (text: string) => {
      dispatch(orgActions.search({ searchTerm: text, searchBy: 'orgs', isActive: true }));
    },
    [dispatch]
  );

  return { search, organisations: searchResults?.orgs || [] };
};

const useDebouncedOrganisationSearch = () => {
  const { search, organisations } = useOrganisationSearch();
  const [searchInput, setSearchInput] = useState('');
  const [debouncedSearchInput, setStateDebounced] = useDebouncedState(searchInput, 300);

  useEffect(() => {
    if (searchInput.length > 2) {
      setStateDebounced(searchInput);
    }
  }, [setStateDebounced, searchInput]);

  useEffect(() => {
    if (debouncedSearchInput.length > 2) {
      search(debouncedSearchInput);
    }
  }, [search, debouncedSearchInput]);

  return { searchInput, setSearchInput, organisations: organisations || [] };
};

export default useDebouncedOrganisationSearch;
